angular.module('natura').provider("pggAdatlapProvider", [function () {
  /**
   * CONFIG
   */
  var config = {
    options: {}
  };

  this.$get = [
    "$http",
    "pggConfigProvider",
    function ($http, pggConfigProvider) {
      /**
       * GETTERS AND SETTERS
       */
      var _getOptions = function () {
        return config.options;
      };
      var _setOptions = function (options) {
        config.options = options;
      };

      /**
       * FUNCTIONS
       */
      var _createTrueFalseOptions = function () {
        return [{
          value: "Igen",
          id: true
        }, {
            value: "Nem",
            id: false
          }];
      };

      var _createYearOptions = function (minYear) {
        var years = [];
        var currentYear = new Date().getFullYear();
        for (var i = currentYear; i >= minYear; i--) {
          years.push({
            value: i,
            id: i
          });
        }
        return years;
      };

      var _createNullOptions = function () {
        return {
          value: null
        };
      };

      var _getDatasheetsByFeatureIdPromise = function (featureId) {
        var promise = $http.get(pggConfigProvider.getBaseUrl() + "/gis/adatlap/gazdalkodasi-terulet/" + featureId)
          .then(function (response) {
            return response;
          });
        return promise;
      };

      var _getDatasheetByFeatureIdAndAdatlapIdPromise = function (featureId, adatlapId) {
        var promise = $http.get(
          pggConfigProvider.getBaseUrl() + "/gis/adatlap/gazdalkodasi-terulet/" + featureId + "/" + adatlapId)
          .then(function (response) {
            return response;
          });
        return promise;
      };

      var _deleteDatasheetPromise = function (datasheet) {
        var promise = $http['delete'](
          pggConfigProvider.getBaseUrl() + "/gis/adatlap/gazdalkodasi-terulet/" + datasheet.id).then(
          function (response) {
            return response;
          });
        return promise;
      };

      var _postDatasheetPromise = function (options) {
        var postData = {
          datasheets: [{
            type: "datasheet",
            vegetable_id: options.vegetable_id,
            vegetable2_id: options.vegetable2_id,
            agronomist_area_geom_id: options.agronomist_area_geom_id,
            agronomist_area_name: options.agronomist_area_name,
            handled_year: options.handled_year,
            area_size: options.area_size,
            saps: options.saps,
            kat_thet: options.kat_thet,
            akg_id: options.akg_id,
            emva: options.emva,
            cultivation_type_id: options.cultivation_type_id
          }]
        };
        var promise = $http.post(pggConfigProvider.getBaseUrl() + "/gis/adatlap/gazdalkodasi-terulet", postData)
          .then(function (response) {
            return response;
          });
        return promise;
      };

      var _putDatasheetPromise = function (options) {
        var putData = {
          datasheets: [{
            type: "datasheet",
            id: options.id,
            vegetable_id: options.vegetable_id,
            vegetable2_id: options.vegetable2_id,
            agronomist_area_geom_id: options.agronomist_area_geom_id,
            agronomist_area_name: options.agronomist_area_name,
            handled_year: options.handled_year,
            area_size: options.area_size,
            saps: options.saps,
            kat_thet: options.kat_thet,
            akg_id: options.akg_id,
            emva: options.emva,
            cultivation_type_id: options.cultivation_type_id
          }]
        };
        var promise = $http.put(pggConfigProvider.getBaseUrl() + "/gis/adatlap/gazdalkodasi-terulet", putData).then(
          function (response) {
            return response;
          });
        return promise;
      };

      var _getOptionsPromise = function () {
        var promise = $http.get(pggConfigProvider.getBaseUrl() + "/q/egyeb").then(function (response) {
          return response;
        });
        return promise;
      };

      var _getOptionForValue = function (select, value) {
        for (var i = 0; i < select.length; i++) {
          if (select[i].value == value) {
            return select[i];
          }
        }
      };

      var _getOptionForId = function (select, id) {
        for (var i = 0; i < select.length; i++) {
          if (select[i].id == id) {
            return select[i];
          }
        }
      };

      var _populateOptions = function () {
        _setOptions({
          vegetable: [],
          vegetable2: [],
          cultivation: [],
          akg: []
        });
        _getOptionsPromise().then(
          function (data) {
            angular.forEach(data.data, function (egyeb) {
              if (egyeb.group == "vegetable") {
                _getOptions().vegetable.push(egyeb);
                _getOptions().vegetable2.push(egyeb);
              } else if (egyeb.group == "cultivation_type") {
                _getOptions().cultivation.push(egyeb);
              } else if (egyeb.group == "akg_type") {
                _getOptions().akg.push(egyeb);
              }
            });
          });
      };

      /**
       * RETURNS
       */
      return {
        getOptions: _getOptions,
        setOptions: _setOptions,
        createTrueFalseOptions: _createTrueFalseOptions,
        createYearOptions: _createYearOptions,
        createNullOptions: _createNullOptions,
        getDatasheetsByFeatureIdPromise: _getDatasheetsByFeatureIdPromise,
        getDatasheetByFeatureIdAndAdatlapIdPromise: _getDatasheetByFeatureIdAndAdatlapIdPromise,
        deleteDatasheetPromise: _deleteDatasheetPromise,
        postDatasheetPromise: _postDatasheetPromise,
        putDatasheetPromise: _putDatasheetPromise,
        getOptionsPromise: _getOptionsPromise,
        getOptionForValue: _getOptionForValue,
        getOptionForId: _getOptionForId,
        populateOptions: _populateOptions
      };
    }];
}]);